/**
 * @author Vivek Kumar<vivek.kumar@314ecorp.com>
 * @description React Hook useUpdatePaymentReconciliation
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';
import AppEvents from '@veritable/common/utils/appEvents';

interface IProps {
	modal: PatientPayment.IPaymentReconciliationPatchModal;
	refetchPaymentList?: boolean;
}
/**
 * useUpdatePaymentReconciliation
 * @returns {UseMutationResult} useUpdatePaymentReconciliation
 */
const useUpdatePaymentReconciliation = (id: string): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ modal }) => {
			await api.PaymentReconciliationApi.patchPaymentReconciliation({
				paymentReconciliationId: id,
				paymentReconciliationModelUpdate: modal,
			});
		},
		onSuccess: (_data, variables) => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.paymentAllocation, { id }] });
			const shouldRefetchPaymentList = variables?.refetchPaymentList ?? true;
			if (shouldRefetchPaymentList) {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.allPaymentAllocations] });
			}
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdatePaymentReconciliation;
